import { formatDuration } from '../../../../shared/sso-workspace/format'
import { utcText } from '../../../../shared/date/local-time'

// How slow is slow: past 300 ms is worth a look, past 1 s is a problem.
export const SLOW_MS = 300
export const VERY_SLOW_MS = 1000

export const msClass = ms => {
  const n = Number(ms)
  if (n >= VERY_SLOW_MS) return 'rl-ms rl-ms-very-slow'
  if (n >= SLOW_MS) return 'rl-ms rl-ms-slow'
  return 'rl-ms'
}

export const formatMs = ms => formatDuration(ms)

// "2026-10-02 10:00:00.250 UTC": the exact time, the same for every reader
// (a time's hover; shared/date/local-time utcText).
export const formatUTC = value => utcText(value)

export const statusTone = status => {
  const n = Number(status)
  if (n >= 500) return 'bad'
  if (n >= 400) return 'warn'
  if (n >= 300) return 'info'
  if (n >= 200) return 'ok'
  return null
}

export const appLabel = r => [r.clientApp, r.clientVersion].filter(Boolean).join(' ')

export const routeLabel = r => r.route || r.path
